module.exports = __webpack_public_path__ + "static/background-4d3f5791333cbacac2bf751195371df1.png";